import { useQuery } from '@src/shared/query';
import { resourceUserFromDto } from '../../lib';
import type { ResourceUser, ResourceUserDto } from '../../types';
import { absToolResourcesUrl } from './constants';

export default function useResourceUsers() {
  const query = useQuery<ResourceUserDto[], ResourceUser[]>(
    absToolResourcesUrl,
    {
      select: (data: Array<ResourceUserDto>) => data.map(resourceUserFromDto),
      initialData: [],
    },
  );

  const { data: users = [], ...restQuery } = query;
  return {
    users,
    ...restQuery,
  };
}
